import React from 'react'
import { SwitchWrapper, SwitchInput, SwitchDot } from './styled'

interface SwitchProps {
  className?: string
  style?: object
}

function Switch(props: React.InputHTMLAttributes<SwitchProps>) {
  return (
    <SwitchWrapper>
      <SwitchInput id="switch" type="checkbox" {...props} />
      <SwitchDot htmlFor="switch" />
    </SwitchWrapper>
  )
}

export default Switch
